import Vue from 'vue';

export default (to, from, next) => {
  if (Vue.auth.check()) {
    next();
  } else {
    Vue.router.push({ name: 'login', query: { redirect: to.fullPath } });
  }
};
